const authMessages = {
    'en': {
        'gui.login.accountDisabled':
            'This account has been disabled. Please contact an administrator.',
        'gui.admin.notAdmin': 'Only administrators can use this feature.',
        'gui.admin.cannotModifySelf':
            'You cannot change your own role or disable your own account.',
        'gui.admin.cannotDeleteSelf': 'You cannot delete your own account.',
        'gui.admin.userNotFound': 'That account no longer exists. Refresh the list.',
        'gui.admin.projectNotFound': 'That project no longer exists. Refresh the list.',
        'gui.admin.invalidRole': 'The role must be either administrator or user.',
        'gui.admin.invalidDisabled': 'The disabled state must be either on or off.',
        'gui.accountMenu.adminPanel': 'Administration',
        'gui.admin.title': 'Administration',
        'gui.admin.tabOverview': 'Overview',
        'gui.admin.tabUsers': 'Users',
        'gui.admin.tabProjects': 'Projects',
        'gui.admin.statUsers': 'Accounts',
        'gui.admin.statAdmins': 'Administrators',
        'gui.admin.statDisabled': 'Disabled',
        'gui.admin.statProjects': 'Projects',
        'gui.admin.statStorage': 'Storage used',
        'gui.admin.columnAccount': 'Account',
        'gui.admin.columnDisplayName': 'Display name',
        'gui.admin.columnCreated': 'Registered',
        'gui.admin.columnProjects': 'Projects',
        'gui.admin.columnRole': 'Role',
        'gui.admin.columnStatus': 'Status',
        'gui.admin.columnActions': 'Actions',
        'gui.admin.columnOwner': 'Owner',
        'gui.admin.columnSize': 'Size',
        'gui.admin.columnUpdated': 'Updated',
        'gui.admin.roleAdmin': 'Administrator',
        'gui.admin.roleUser': 'User',
        'gui.admin.statusActive': 'Active',
        'gui.admin.statusDisabled': 'Disabled',
        'gui.admin.disable': 'Disable',
        'gui.admin.enable': 'Enable',
        'gui.admin.promote': 'Make admin',
        'gui.admin.demote': 'Remove admin',
        'gui.admin.resetPassword': 'Reset password',
        'gui.admin.remove': 'Delete',
        'gui.admin.cancel': 'Cancel',
        'gui.admin.confirm': 'Confirm',
        'gui.admin.newPassword': 'New password',
        'gui.admin.save': 'Save',
        'gui.admin.loading': 'Loading\u2026',
        'gui.admin.emptyUsers': 'No accounts yet.',
        'gui.admin.emptyProjects': 'No projects yet.',
        'gui.admin.orphaned': '(account removed)',
        'gui.admin.confirmDeleteUser':
            'Delete the account {account}? Its projects are deleted too, and this cannot be undone.',
        'gui.admin.confirmDeleteProject':
            'Delete the project "{name}"? This cannot be undone.',
        'gui.admin.confirmResetPassword': 'Set a new password for {account} (at least 10 characters):',
        'gui.admin.passwordTooShort': 'The password must be at least 10 characters.',
        'gui.admin.reload': 'Refresh',
        'gui.admin.done': 'Done.',
        'gui.login.account': 'Account',
        'gui.login.accountExists': 'This account is already registered. Please sign in or choose another account.',
        'gui.login.displayName': 'Display name',
        'gui.login.empty': 'Please enter your account and password.',
        'gui.login.invalidAccount':
            'Accounts must be 3-32 characters using letters, numbers, underscore, hyphen or dot.',
        'gui.login.invalidDisplayName': 'Display name cannot be empty or longer than 64 characters.',
        'gui.login.invalidCredentials':
            'Incorrect account or password. If you have not registered yet, use "New here? Create an account" below.',
        'gui.login.invalidPassword': 'Password must be 10-128 characters. {min}-{max} recommended.',
        'gui.login.malformedRequest':
            'The submitted data was malformed. Please try again, or check the server terminal output.',
        'gui.login.passwordHint': 'At least {min} characters.',
        'gui.login.failed': 'The request failed. Please check your details or network and try again.',
        'gui.login.serverError':
            'The authentication service returned an error (HTTP {status}). Check the server terminal output.',
        'gui.login.network': 'Unable to reach the authentication service. Please make sure the server is running.',
        'gui.login.password': 'Password',
        'gui.login.rateLimited': 'Too many attempts. Please try again later.',
        'gui.login.requestTooLarge': 'The submitted content is too large. Please shorten it and try again.',
        'gui.myProjects.openFailed': 'Could not open the project; its content may be damaged.',
        'gui.myProjects.unreadable': 'Saved by an older version, this project is damaged and ' +
            'cannot be opened. Please save it again.',
        'gui.login.registerEmptyDisplayName': 'Please enter a display name to register.',
        'gui.login.registerSubmit': 'Register and sign in',
        'gui.login.registerTitle': 'Create account',
        'gui.login.submit': 'Log In',
        'gui.login.submitting': 'Working…',
        'gui.login.switchToLogin': 'Already have an account? Log in',
        'gui.login.switchToRegister': 'New here? Create an account',
        'gui.login.title': 'Log In',
        'gui.login.serviceMisconfigured':
            'The authentication service rejected this request (origin or route ' +
            'mismatch). Check GUI_ORIGIN and the service version.',
        'gui.menuBar.login': 'Log In',
        'gui.menuBar.myStuff': 'My Stuff',
        'gui.menuBar.hostAccount': 'Account',
        'gui.menuBar.hostSave': 'Save',
        'gui.menuBar.hostSubmit': 'Save & Submit',
        'gui.menuBar.hostFullscreen': 'Fullscreen',
        'gui.menuBar.logout': 'Log Out',
        'gui.menuBar.saveToAccount': 'Save',
        'gui.menuBar.savingToAccount': 'Saving...',
        'gui.menuBar.savedToAccount': 'Saved',
        'gui.accountMenu.label': 'Account menu',
        'gui.accountMenu.myProjects': 'My Projects',
        'gui.myProjects.title': 'My Projects',
        'gui.myProjects.saveCurrent': 'Save the current project',
        'gui.myProjects.projectName': 'Project name',
        'gui.myProjects.save': 'Save',
        'gui.myProjects.saving': 'Saving…',
        'gui.myProjects.savedList': 'Saved projects',
        'gui.myProjects.loading': 'Loading…',
        'gui.myProjects.empty':
            'No saved projects yet. Enter a name and press Save to store the current project in your account.',
        'gui.myProjects.open': 'Open',
        'gui.myProjects.overwrite': 'Overwrite',
        'gui.myProjects.remove': 'Delete',
        'gui.myProjects.cancel': 'Cancel',
        'gui.myProjects.confirmRemove': 'Delete "{name}"? This cannot be undone.',
        'gui.myProjects.saved': 'Saved "{name}".',
        'gui.myProjects.opened': 'Opened "{name}".',
        'gui.myProjects.removed': 'Deleted "{name}".',
        'gui.myProjects.nameRequired': 'Please enter a project name first.',
        'gui.accountSettings.title': 'Account Settings',
        'gui.accountSettings.account': 'Account',
        'gui.accountSettings.accountHint': 'The account name is used to sign in and cannot be changed.',
        'gui.accountSettings.displayName': 'Display name',
        'gui.accountSettings.saveProfile': 'Save display name',
        'gui.accountSettings.profileSaved': 'Display name updated.',
        'gui.accountSettings.passwordHeading': 'Change password',
        'gui.accountSettings.currentPassword': 'Current password',
        'gui.accountSettings.newPassword': 'New password',
        'gui.accountSettings.confirmPassword': 'Confirm new password',
        'gui.accountSettings.savePassword': 'Change password',
        'gui.accountSettings.passwordSaved': 'Password changed. Please sign in with the new password.',
        'gui.accountSettings.passwordHint': 'The new password must be {min}-{max} characters.',
        'gui.accountSettings.passwordMismatch': 'The two new passwords do not match.',
        'gui.accountSettings.passwordTooShort': 'The new password must be {min}-{max} characters.',
        'gui.accountSettings.displayNameRequired': 'Display name cannot be empty.'
    },
    'zh-cn': {
        'gui.accountMenu.adminPanel': '管理后台',
        'gui.admin.title': '管理后台',
        'gui.admin.tabOverview': '概览',
        'gui.admin.tabUsers': '用户',
        'gui.admin.tabProjects': '作品',
        'gui.admin.statUsers': '账号总数',
        'gui.admin.statAdmins': '管理员',
        'gui.admin.statDisabled': '已禁用',
        'gui.admin.statProjects': '作品总数',
        'gui.admin.statStorage': '存储占用',
        'gui.admin.columnAccount': '账号',
        'gui.admin.columnDisplayName': '昵称',
        'gui.admin.columnCreated': '注册时间',
        'gui.admin.columnProjects': '作品数',
        'gui.admin.columnRole': '角色',
        'gui.admin.columnStatus': '状态',
        'gui.admin.columnActions': '操作',
        'gui.admin.columnOwner': '所属账号',
        'gui.admin.columnSize': '大小',
        'gui.admin.columnUpdated': '更新时间',
        'gui.admin.roleAdmin': '管理员',
        'gui.admin.roleUser': '普通用户',
        'gui.admin.statusActive': '正常',
        'gui.admin.statusDisabled': '已禁用',
        'gui.admin.disable': '禁用',
        'gui.admin.enable': '启用',
        'gui.admin.promote': '设为管理员',
        'gui.admin.demote': '取消管理员',
        'gui.admin.resetPassword': '重置密码',
        'gui.admin.remove': '删除',
        'gui.admin.cancel': '取消',
        'gui.admin.confirm': '确认',
        'gui.admin.newPassword': '新密码',
        'gui.admin.save': '保存',
        'gui.admin.loading': '正在加载\u2026',
        'gui.admin.emptyUsers': '还没有任何账号。',
        'gui.admin.emptyProjects': '还没有任何作品。',
        'gui.admin.orphaned': '（账号已删除）',
        'gui.admin.confirmDeleteUser':
            '确定删除账号 {account} 吗？该账号的作品也会一并删除，且无法恢复。',
        'gui.admin.confirmDeleteProject': '确定删除作品《{name}》吗？该操作无法恢复。',
        'gui.admin.confirmResetPassword': '为账号 {account} 设置一个新密码（至少 10 位）：',
        'gui.admin.passwordTooShort': '密码长度至少 10 位。',
        'gui.admin.reload': '刷新',
        'gui.admin.done': '已完成。',
        'gui.login.accountDisabled': '该账号已被禁用，请联系管理员。',
        'gui.admin.notAdmin': '只有管理员可以访问该功能。',
        'gui.admin.cannotModifySelf': '不能修改自己的角色或禁用自己的账号。',
        'gui.admin.cannotDeleteSelf': '不能删除自己的账号。',
        'gui.admin.userNotFound': '该账号已不存在，请刷新列表。',
        'gui.admin.projectNotFound': '该作品已不存在，请刷新列表。',
        'gui.admin.invalidRole': '角色只能是管理员或普通用户。',
        'gui.admin.invalidDisabled': '禁用状态只能是开或关。',
        'gui.login.account': '账号',
        'gui.login.accountExists': '该账号已被注册，请直接登录或更换账号。',
        'gui.login.displayName': '显示名称',
        'gui.login.empty': '请输入账号和密码。',
        'gui.login.invalidAccount': '账号需为 3–32 位字母、数字、下划线、连字符或点号。',
        'gui.login.invalidDisplayName': '显示名称不能为空，且不能超过 64 个字符。',
        'gui.login.invalidCredentials': '账号或密码错误。若尚未注册，请点下方「没有账号？立即注册」。',
        'gui.login.invalidPassword': '密码长度需为 10–128 位，当前不符合要求。',
        'gui.login.malformedRequest': '提交的数据格式异常，请重试；若持续出现请查看后端终端输出。',
        'gui.login.passwordHint': '至少 {min} 位字符。',
        'gui.login.failed': '操作失败，请检查输入内容或网络后重试。',
        'gui.login.serverError': '认证服务返回了错误（HTTP {status}），请查看后端终端输出。',
        'gui.login.network': '无法连接认证服务，请确认后端已启动。',
        'gui.login.password': '密码',
        'gui.login.rateLimited': '尝试过于频繁，请稍后再试。',
        'gui.login.requestTooLarge': '提交内容过大，请缩短后重试。',
        'gui.myProjects.openFailed': '打开作品失败，内容可能已损坏。',
        'gui.myProjects.unreadable': '这个作品是在旧版本里保存的，内容已经损坏，无法打开。请重新保存一次。',
        'gui.login.registerEmptyDisplayName': '注册时请输入显示名称。',
        'gui.login.registerSubmit': '注册并登录',
        'gui.login.registerTitle': '注册账号',
        'gui.login.submit': '登录',
        'gui.login.submitting': '处理中…',
        'gui.login.switchToLogin': '已有账号？去登录',
        'gui.login.switchToRegister': '没有账号？立即注册',
        'gui.login.title': '登录',
        'gui.login.serviceMisconfigured': '认证服务的来源或接口配置不匹配，请确认 GUI_ORIGIN 配置与所用版本。',
        'gui.menuBar.login': '登录',
        'gui.menuBar.myStuff': '我的作品',
        'gui.menuBar.hostAccount': '账号',
        'gui.menuBar.hostSave': '保存',
        'gui.menuBar.hostSubmit': '保存并提交',
        'gui.menuBar.hostFullscreen': '全屏',
        'gui.menuBar.logout': '退出登录',
        'gui.menuBar.saveToAccount': '保存',
        'gui.menuBar.savingToAccount': '保存中…',
        'gui.menuBar.savedToAccount': '已保存',
        'gui.accountMenu.label': '账号菜单',
        'gui.accountMenu.myProjects': '我的作品',
        'gui.myProjects.title': '我的作品',
        'gui.myProjects.saveCurrent': '保存当前作品',
        'gui.myProjects.projectName': '作品名称',
        'gui.myProjects.save': '保存',
        'gui.myProjects.saving': '保存中…',
        'gui.myProjects.savedList': '已保存的作品',
        'gui.myProjects.loading': '正在加载…',
        'gui.myProjects.empty': '还没有保存过作品。填写名称后点“保存”即可存到你的账号。',
        'gui.myProjects.open': '打开',
        'gui.myProjects.overwrite': '覆盖',
        'gui.myProjects.remove': '删除',
        'gui.myProjects.cancel': '取消',
        'gui.myProjects.confirmRemove': '确定要删除《{name}》吗？此操作无法撤销。',
        'gui.myProjects.saved': '已保存《{name}》。',
        'gui.myProjects.opened': '已打开《{name}》。',
        'gui.myProjects.removed': '已删除《{name}》。',
        'gui.myProjects.nameRequired': '请先填写作品名称。',
        'gui.accountSettings.title': '账号设置',
        'gui.accountSettings.account': '账号',
        'gui.accountSettings.accountHint': '账号是登录用的标识，不能修改。',
        'gui.accountSettings.displayName': '显示名称',
        'gui.accountSettings.saveProfile': '保存显示名称',
        'gui.accountSettings.profileSaved': '显示名称已更新。',
        'gui.accountSettings.passwordHeading': '修改密码',
        'gui.accountSettings.currentPassword': '当前密码',
        'gui.accountSettings.newPassword': '新密码',
        'gui.accountSettings.confirmPassword': '确认新密码',
        'gui.accountSettings.savePassword': '修改密码',
        'gui.accountSettings.passwordSaved': '密码已修改，请用新密码登录。',
        'gui.accountSettings.passwordHint': '新密码需为 {min}-{max} 位。',
        'gui.accountSettings.passwordMismatch': '两次输入的新密码不一致。',
        'gui.accountSettings.passwordTooShort': '新密码长度需为 {min}-{max} 位。',
        'gui.accountSettings.displayNameRequired': '显示名称不能为空。'
    }
};

export default authMessages;
